import { APP_CONFIG, MOBILE_VIEW_THRESHOLD_PX, ROUTE_CREATE_ACCOUNT, ROUTE_LANDING } from '@1bill-app/constants';
import { environment } from '@1bill-app/env';
import { Component, OnInit } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { NavController, Platform, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.page.html',
  styleUrls: ['./terms.page.scss'],
})
export class TermsPage implements OnInit {
  terms1 = false;
  terms2 = false;
  landingPage = ROUTE_LANDING;
  termsLink = environment.appTerms;
  privacyPolicy = environment.appPrivacyPolicy;
  privacyCollectionPolicy = environment.appPrivacyCollectionPolicy;

  get isDesktopView() {
    return this.platform.width() >= MOBILE_VIEW_THRESHOLD_PX;
  }
  constructor(
    private navCtrl: NavController,
    private toastController: ToastController,
    private platform: Platform,
  ) { }

  ngOnInit() {
  }

  async onClickProceed(){
    // removing terms2 as it's only marketing related (per request from Penni)
    if(this.terms1){
      this.navCtrl.navigateForward([ROUTE_CREATE_ACCOUNT])
    }else{
      const toast = await this.toastController.create({
        message: 'Please agree to 1bill terms and conditions.',
        duration: APP_CONFIG.TOAST_ERROR_DURATION,
        color:'warning'
      });
      toast.present();
    }
  }

  /**
   * Opens the url.
   * In-app browser in app.
   * External tab in web.
   *
   *
   */
  openWindow(url: string) {
    Browser.open({
      presentationStyle: 'fullscreen',
      url,
      windowName: '_blank',
    });
  }

}
